/* UW product page behavior (mockup: underwear-wanted-PRODUCT-latest).
   - Gallery shows ONLY the selected color's photos; color change resets to photo 1.
   - Pills (sizes) show only values that exist for the selected color; existing
     but unavailable values render sold-out (hatched) and stay selectable so the
     shopper can see what is out (and so the restock CTA can appear IF the
     show_restock setting is ever turned on — it is off, and no restock alerts
     are offered, so no copy may promise one).
   - Stock line + quantity stepper read the live inventory snapshot rendered
     into the page JSON; thresholds come from section settings.
   - Add-to-cart posts through Dawn's <product-form> (cart notification/drawer
     machinery untouched). */

(function () {
  'use strict';

  function init(section) {
    var jsonEl = section.querySelector('[data-uw-product-json]');
    if (!jsonEl) return;
    var data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var $ = function (sel) {
      return section.querySelector(sel);
    };
    var $$ = function (sel) {
      return Array.prototype.slice.call(section.querySelectorAll(sel));
    };

    var mainImg = $('[data-uw-main-img]');
    var mainStage = $('[data-uw-main]');
    var countEl = $('[data-uw-count]');
    var thumbsWrap = $('[data-uw-thumbs]');
    var priceWrap = $('[data-uw-price-wrap]');
    var priceEl = $('[data-uw-price]');
    var compareEl = $('[data-uw-compare]');
    var saleFlag = $('[data-uw-sale-flag]');
    var stockline = $('[data-uw-stockline]');
    var qtyInput = $('[data-uw-qty]');
    var qtyMinus = $('[data-uw-qty-minus]');
    var qtyPlus = $('[data-uw-qty-plus]');
    var atcBtn = $('[data-uw-atc]');
    var atcText = $('[data-uw-atc-text]');
    var notifyLink = $('[data-uw-notify]');
    var variantInput = $('[data-uw-variant-id]');
    var colorNameEl = $('[data-uw-color-name]');
    var form = variantInput ? variantInput.closest('form') : null;

    var bar = section.querySelector('[data-uw-bar]');
    var barImg = section.querySelector('[data-uw-bar-img]');
    var barMeta = section.querySelector('[data-uw-bar-meta]');
    var barPrice = section.querySelector('[data-uw-bar-price]');
    var barBtn = section.querySelector('[data-uw-bar-btn]');

    var colorIdx = data.colorOptionIndex;
    var optionNames = data.optionNames || [];
    var sel = [];
    for (var i = 0; i < data.optionCount; i++) sel.push(null);

    // Initial selection: deep link (?variant=) preselects everything; otherwise
    // only the color is chosen and the shopper picks a size (mockup behavior).
    if (data.singleVariant && data.variants.length) {
      sel = data.variants[0].options.slice();
    } else if (data.hasDeepLink && variantInput && variantInput.value) {
      var dv = findById(variantInput.value);
      if (dv) sel = dv.options.slice();
    } else if (colorIdx != null && data.initialColor) {
      sel[colorIdx] = data.initialColor;
    }

    function findById(id) {
      id = String(id);
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === id) return data.variants[i];
      }
      return null;
    }

    function matches(variant, selection, ignoreIdx) {
      for (var i = 0; i < selection.length; i++) {
        if (i === ignoreIdx || selection[i] == null) continue;
        if (variant.options[i] !== selection[i]) return false;
      }
      return true;
    }

    function currentVariant() {
      for (var i = 0; i < sel.length; i++) if (sel[i] == null) return null;
      for (var j = 0; j < data.variants.length; j++) {
        if (matches(data.variants[j], sel, -1)) return data.variants[j];
      }
      return null;
    }

    function variantIsOut(v) {
      return !v.available;
    }

    function colorSoldOut(color) {
      return !data.variants.some(function (v) {
        return colorIdx != null && v.options[colorIdx] === color && v.available;
      });
    }

    /* ── Gallery ── */
    var allThumbs = thumbsWrap ? $$('.uw-pdp-thumb') : [];
    var photoIndex = 0;

    function visibleThumbs() {
      var color = colorIdx != null ? sel[colorIdx] : null;
      if (color == null && colorIdx != null) color = data.initialColor;
      return allThumbs.filter(function (t) {
        return colorIdx == null || t.getAttribute('data-uw-color') === color;
      });
    }

    function applyGallery(reset) {
      var color = colorIdx != null ? sel[colorIdx] : null;
      allThumbs.forEach(function (t) {
        var mine = colorIdx == null || t.getAttribute('data-uw-color') === color;
        t.hidden = !mine;
      });
      if (reset) photoIndex = 0;
      showPhoto(photoIndex);
    }

    function showPhoto(i) {
      var vis = visibleThumbs();
      if (!vis.length || !mainImg) {
        if (countEl) countEl.textContent = '1 / 1';
        return;
      }
      if (i >= vis.length) i = 0;
      photoIndex = i;
      var t = vis[i];
      mainImg.src = t.getAttribute('data-main-src');
      mainImg.srcset = t.getAttribute('data-main-srcset') || '';
      mainImg.alt = t.getAttribute('data-alt') || '';
      if (countEl) countEl.textContent = i + 1 + ' / ' + vis.length;
      vis.forEach(function (el, idx) {
        el.classList.toggle('is-active', idx === i);
        el.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });
      if (barImg) {
        barImg.src = mainImg.src;
        barImg.hidden = false;
      }
    }

    allThumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var vis = visibleThumbs();
        showPhoto(vis.indexOf(t));
      });
    });

    if (mainStage) {
      mainStage.addEventListener('click', function () {
        var vis = visibleThumbs();
        if (vis.length > 1) showPhoto((photoIndex + 1) % vis.length);
      });
    }

    /* ── Options ── */
    var swatches = $$('[data-uw-swatch]');
    swatches.forEach(function (b) {
      b.addEventListener('click', function () {
        selectOption(colorIdx, b.getAttribute('data-uw-swatch'), true);
      });
    });

    var pillGroups = $$('[data-uw-pills]');
    pillGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-opt-index'), 10);
      Array.prototype.slice.call(group.querySelectorAll('[data-uw-pill]')).forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.classList.contains('is-absent')) return;
          selectOption(idx, b.getAttribute('data-uw-pill'), false);
        });
      });
    });

    function selectOption(idx, value, isColor) {
      if (idx == null) return;
      sel[idx] = value;
      if (isColor) {
        swatches.forEach(function (b) {
          var on = b.getAttribute('data-uw-swatch') === value;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (colorNameEl) colorNameEl.textContent = value;
        applyGallery(true);
      }
      refreshPills();
      refreshSwatches();
      updatePanel();
    }

    // Per selected color: hide values with no variant, hatch values whose
    // variants are all unavailable. Other already-picked options are respected.
    function refreshPills() {
      pillGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-opt-index'), 10);
        Array.prototype.slice.call(group.querySelectorAll('[data-uw-pill]')).forEach(function (b) {
          var value = b.getAttribute('data-uw-pill');
          var exists = false;
          var anyAvailable = false;
          data.variants.forEach(function (v) {
            if (v.options[idx] !== value) return;
            if (!matches(v, sel, idx)) return;
            exists = true;
            if (v.available) anyAvailable = true;
          });
          b.classList.toggle('is-absent', !exists);
          b.classList.toggle('is-out', exists && !anyAvailable);
          if (!exists && sel[idx] === value) sel[idx] = null;
          var on = sel[idx] === value;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
    }

    // Same question as refreshPills, asked of the colors: given everything else
    // already picked (size, usually), is this color out? Liquid bakes in a
    // size-AGNOSTIC is-out, so a color sold out only in the chosen size looked
    // identical to one in stock — this overwrites that on every selection.
    // DELIBERATELY UNLIKE refreshPills: no is-absent and nothing is hidden or
    // disabled. Colors stay clickable so a shopper can pick one and then see
    // which sizes it comes in; hiding them would also make the row reflow.
    function refreshSwatches() {
      if (colorIdx == null) return;
      swatches.forEach(function (b) {
        var value = b.getAttribute('data-uw-swatch');
        var exists = false;
        var anyAvailable = false;
        data.variants.forEach(function (v) {
          if (v.options[colorIdx] !== value) return;
          if (!matches(v, sel, colorIdx)) return;
          exists = true;
          if (v.available) anyAvailable = true;
        });
        var isOut = exists && !anyAvailable;
        b.classList.toggle('is-out', isOut);
        // The server-rendered "(sold out)" suffix goes stale as soon as a size is
        // picked, so rebuild the label from the color value rather than trying to
        // strip it back off.
        b.setAttribute('aria-label', isOut ? value + ' (sold out)' : value);
      });
    }

    /* ── Stock line / price / CTA / quantity ── */
    function selectedLabel() {
      return sel
        .filter(function (v) {
          return v != null;
        })
        .join(' / ');
    }

    function missingOptionName() {
      for (var i = 0; i < sel.length; i++) {
        if (sel[i] == null) return optionNames[i] || 'option';
      }
      return null;
    }

    function qtyMax(v) {
      if (!v || variantIsOut(v)) return 1;
      if (!v.tracked) return 99;
      return Math.max(v.qty, 1);
    }

    function clampQty(v) {
      var max = qtyMax(v);
      var val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (val > max) val = max;
      qtyInput.value = val;
      qtyInput.max = max;
      qtyMinus.disabled = val <= 1;
      qtyPlus.disabled = val >= max;
    }

    function setStock(cls, text) {
      stockline.className = 'uw-stockline ' + cls;
      stockline.textContent = text;
    }

    function updatePanel() {
      var v = currentVariant();
      var full = v != null;

      // Price: full selection wins; else first variant of the selected color.
      var priceSource = v;
      if (!priceSource && colorIdx != null && sel[colorIdx]) {
        priceSource = data.variants.filter(function (x) {
          return x.options[colorIdx] === sel[colorIdx];
        })[0];
      }
      if (!priceSource) priceSource = data.variants[0];
      if (priceSource && priceEl) {
        priceEl.textContent = priceSource.price;
        var onSale = !!priceSource.compare;
        if (compareEl) {
          compareEl.hidden = !onSale;
          compareEl.textContent = onSale ? priceSource.compare : '';
        }
        if (priceWrap) priceWrap.classList.toggle('on-sale', onSale);
        if (saleFlag) saleFlag.hidden = !onSale;
        if (barPrice) barPrice.textContent = priceSource.price;
      }
      if (barMeta) barMeta.textContent = selectedLabel();

      if (!full) {
        var colorPicked = colorIdx != null && sel[colorIdx];
        var colorGone = colorPicked && colorSoldOut(sel[colorIdx]);
        if (colorGone) {
          // No restock alerts are offered (show_restock is off and there is no
          // back-in-stock app), so this must not promise one. State the fact:
          // colorSoldOut() means no variant of this color is available at all.
          // 'out', not 'hint': this is a sold-out statement, so it gets the same
          // red as "Sold out — <size> / <color>". 'hint' is grey, for guidance
          // like "Select a size".
          setStock('out', 'This color is sold out in every size');
        } else {
          var missing = missingOptionName();
          setStock('hint', missing ? 'Select a ' + missing.toLowerCase() : '');
        }
        variantInput.value = '';
        atcBtn.setAttribute('disabled', 'disabled');
        // The button is disabled either way in this branch — the label just has
        // to be truthful. "Add to cart" while every size of the chosen color is
        // gone reads as though picking a size could still work.
        atcText.textContent = colorGone ? 'Sold out' : 'Add to cart';
        if (notifyLink) notifyLink.hidden = true;
        var pf = atcBtn.closest('product-form');
        if (pf) pf.hidden = false;
        if (barBtn) {
          barBtn.textContent = colorGone ? 'Sold out' : 'Add to cart';
          barBtn.classList.toggle('is-notify', colorGone);
        }
        clampQty(null);
        return;
      }

      variantInput.value = v.id;
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      var productForm = atcBtn.closest('product-form');
      if (variantIsOut(v)) {
        setStock('out', 'Sold out — ' + selectedLabel());
        if (notifyLink) {
          if (productForm) productForm.hidden = true;
          notifyLink.hidden = false;
          if (barBtn) {
            barBtn.textContent = 'Email me when it’s back';
            barBtn.classList.add('is-notify');
          }
        } else {
          // Restock CTA disabled in settings: plain disabled Sold out button.
          if (productForm) productForm.hidden = false;
          atcBtn.setAttribute('disabled', 'disabled');
          atcText.textContent = 'Sold out';
          if (barBtn) {
            barBtn.textContent = 'Sold out';
            barBtn.classList.add('is-notify');
          }
        }
      } else {
        if (productForm) productForm.hidden = false;
        if (notifyLink) notifyLink.hidden = true;
        atcBtn.removeAttribute('disabled');
        atcText.textContent = 'Add to cart';
        if (barBtn) {
          barBtn.textContent = 'Add to cart';
          barBtn.classList.remove('is-notify');
        }
        if (!v.tracked) {
          setStock('ok', 'In stock');
        } else if (v.qty <= data.lowStock) {
          setStock('low', (v.qty === 1 ? 'Last one' : 'Only ' + v.qty + ' left') + ' in ' + selectedLabel());
        } else if (v.qty <= data.showCountUpTo) {
          setStock('ok', v.qty + ' in stock');
        } else {
          setStock('ok', data.showCountUpTo + '+ in stock');
        }
      }
      clampQty(v);
    }

    qtyMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      clampQty(currentVariant());
    });
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      clampQty(currentVariant());
    });
    qtyInput.addEventListener('change', function () {
      clampQty(currentVariant());
    });

    /* ── Size guide link opens the accordion ── */
    var guideBtn = $('[data-uw-size-guide]');
    var sizeAcc = $('[data-uw-size-acc]');
    if (guideBtn && sizeAcc) {
      guideBtn.addEventListener('click', function () {
        sizeAcc.open = true;
        sizeAcc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* ── Sticky bar ── */
    function setBarVisible(on) {
      if (!bar) return;
      bar.classList.toggle('show', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (barBtn) barBtn.tabIndex = on ? 0 : -1;
    }
    setBarVisible(false);

    var ctaArea = section.querySelector('.uw-pdp-cta');
    if (bar && ctaArea && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          setBarVisible(!entries[0].isIntersecting);
        },
        { rootMargin: '0px 0px -10px 0px' }
      ).observe(ctaArea);
    }

    if (barBtn) {
      barBtn.addEventListener('click', function () {
        var v = currentVariant();
        if (v && !variantIsOut(v) && form) {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        } else if (v && variantIsOut(v) && notifyLink) {
          window.location.href = notifyLink.href;
        } else {
          var buy = section.querySelector('.uw-pdp-buy');
          if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    /* ── First paint ── */
    refreshPills();
    refreshSwatches();
    applyGallery(true);
    updatePanel();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('.uw-product-section')).forEach(function (s) {
      if (s.dataset.uwInit) return;
      s.dataset.uwInit = '1';
      init(s);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
